import { axiosPrivate } from "../../api/axios";

const createWithdrawalRequest = async (requestData) => {
  const response = await axiosPrivate.post(`/withdrawals`, requestData);
  return response.data;
};

const getUserWithdrawalRequests = async () => {
  const response = await axiosPrivate.get(`/withdrawals`);
  return response.data;
};

const getWithdrawalRequest = async (id) => {
  const response = await axiosPrivate.get(`/withdrawals/${id}`);
  return response.data;
};

const cancelWithdrawalRequest = async (id) => {
  const response = await axiosPrivate.put(`/withdrawals/${id}/status`, {
    status: "rejected",
    reason: "Cancelled by user",
  });
  return response.data;
};

const withdrawalService = {
  createWithdrawalRequest,
  getUserWithdrawalRequests,
  getWithdrawalRequest,
  cancelWithdrawalRequest,
};

export default withdrawalService;
